// From https://github.com/alpinejs/alpine/discussions/1708
//
// This is dangerous stuff as we potentially work with UGC and/or
// translations which aren't considered safe enough.
//
// Hardened by Digiforma for Digiforma's usage
//
// Here's an example of a possible attack:
// <span x-template>
//   <%= gettext(
//     "${alert(1)} alert(1) <script>alert(1)</script> %{alert(1)} {{thing,alert(1)}} de %{recipients} (%{count})`, alert(1), `",
//     recipients: "{{recipientsLabel}}",
//     count: "{{pickedRecipients.length}}"
//   ) %>
// </span>
export default (Alpine) => {
  Alpine.directive("template", function (el, { expression }, { effect, evaluateLater }) {
    let evalStr = expression ? expression : el.innerText;

    // Replace backticks with unicode equivalent, this is the only important
    // symbol, but let's do , ; and $ too for good measure
    evalStr = evalStr.replace(/`/g, "\\u0060").replace(/,/g, "\\u002C").replace(/;/g, "\\u003B").replace(/\$/g, "\\u0024");

    // Replace {{group}} with ${group}
    // Only match things that look like a variable name (with . to access
    // properties)
    // - This prevents function calls, so a lot of XSS possible vulnerabilities
    // - Plus we restrict access to $data, so no access to global scope
    // - , or ; can be used to escape this restriction, so forbid them
    evalStr = evalStr.replace(/{{([\w.]*?)}}/g, (_, group) => {
      return "${$data." + group + "}";
    });

    // Wrap in backticks (template literal), at this point evalStr NEEDS to be
    // safe, e.g. it cannot contain any backtick that could escape the
    // template, etc.
    evalStr = "`" + evalStr + "`";

    const evaluate = evaluateLater(evalStr);

    effect(() => {
      evaluate((value) => {
        el.textContent = value;
      });
    });
  });
};
